import React from 'react'
import { Center } from 'front-end/src/components'
import { brandColors } from '../../../../../shared/basicPalette'
import IconPinSVG from '../icon/IconPinSVG'
import { WorkbookStatusEnum } from '../../../graphql/private/PrivateSchemaTypes'
import { PathwayEnrolmentStatusEnum } from '../../../graphql/public/PublicSchemaTypes'

export const CardAssignedPin = ({
  status
}: {
  status: WorkbookStatusEnum | PathwayEnrolmentStatusEnum
}) => (
  <Center
    top="-8px"
    right="-8px"
    borderRadius="50%"
    position="absolute"
    boxSize={['32px', '39px']}
    color={
      status === WorkbookStatusEnum.OVERDUE ||
      status === WorkbookStatusEnum.IN_PROGRESS
        ? 'white'
        : 'black'
    }
    bgColor={
      status === WorkbookStatusEnum.OVERDUE
        ? brandColors.red.mid
        : status === WorkbookStatusEnum.IN_PROGRESS
        ? brandColors.blue.mid
        : brandColors.yellow.mid
    }
  >
    <IconPinSVG h={['16px', '22px']} w={['15px', '21px']} />
  </Center>
)
